import { getType } from 'typesafe-actions';
import { setFile } from '../actions/file';
var initialState = null;
var fileReducer = function fileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case getType(setFile):
      return action.payload;
    default:
      return state;
  }
};
export default fileReducer;